module.exports = __webpack_public_path__ + "img/img-minting-title.0a76f685.png";